<dx-popup #dlgSaleItemEditor [width]="600" [height]="400" [showTitle]="true" title="Item Details" [resizeEnabled]=true
    (onShowing)="onShowing($event)" (onHiding)="onHiding($event)" [dragEnabled]="true" [showCloseButton]="true"
    [hideOnOutsideClick]="false">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view width="100%" height="100%" [direction]="vertical" [showScrollbar]="always">
            <div class="saleItemDlgContainer">
                <div id="SaleItemLeft" class="saleItemDlgLeft">
                    <!-- Menu -->
                    <dx-button (onClick)="btnResetPrice($event)" class="saleItemMenuButton" text="Reset Price"
                        [disabled]="DisableResetPrice">
                    </dx-button>
                    <dx-button (onClick)="btnUpdateItem($event)" class="saleItemMenuButton" text="Save">
                    </dx-button>
                    <dx-button (onClick)="btnCancel($event)" class="saleItemMenuButton" text="Cancel">
                    </dx-button>
                </div>
                <div id="SaleItemRight" class="saleItemDlgRight">
                    <div style="margin: 5px 20px 5px 20px;min-height: 200px;">
                        <div class="dx-fieldset-header">Item Details</div>
                        <dx-form [showColonAfterLabel]="false" colCount="1" [formData]="saleItemDetail" colCount="2">
                            <dxi-item itemType="simple" colSpan="2" dataField="TypeDesc"
                                [editorOptions]="{disabled:true}">
                                <dxo-label text="Type"></dxo-label>
                            </dxi-item>
                            <dxi-item itemType="simple" colSpan="2" dataField="Description"
                                [editorOptions]="{disabled:true}">
                                <dxo-label text="Description"></dxo-label>
                            </dxi-item>

                            <dxi-item dataField="Price" editorType="dxNumberBox"
                                [disabled]="this.saleItemDetail.IsVoucher" [editorOptions]="ItemPriceEditorOptions">
                                <dxo-label text="Price"></dxo-label>
                            </dxi-item>                            
                            <dxi-item itemType="empty">
                            </dxi-item>


                            <dxi-item
                                [visible]="this.saleItemDetail.SaleItemType!=3 && this.saleItemDetail.IsVoucher==true"
                                dataField="CashValue" editorType="dxNumberBox"
                                [editorOptions]="{'disabled':true,  format: '£#,##0.00'}">
                                <dxo-label text="Voucher Value"></dxo-label>
                            </dxi-item>
                            <dxi-item itemType="empty"
                                [visible]="this.saleItemDetail.SaleItemType!=3 && this.saleItemDetail.IsVoucher==true">
                            </dxi-item>


                            <dxi-item
                                [visible]="this.saleItemDetail.SaleItemType!=3 && this.saleItemDetail.IsVoucher==false"
                                dataField="Qty" editorType="dxNumberBox" [editorOptions]="ItemQtyEditorOptions">
                                <dxo-label text="Quantity"></dxo-label>
                            </dxi-item>
                            <dxi-item itemType="empty"
                                [visible]="this.saleItemDetail.SaleItemType!=3 && this.saleItemDetail.IsVoucher==false">
                            </dxi-item>


                            <dxi-item [colSpan]="2"
                                [visible]="this.saleItemDetail.SaleItemType!=3 && this.saleItemDetail.IsVoucher==true"
                                dataField="VoucherCode" editorType="dxTextBox" [editorOptions]="{'disabled':true}">
                                <dxo-label text="Voucher Code"></dxo-label>
                            </dxi-item>

                            <dxi-item dataField="DiscountCode" [colSpan]="2" editorType="dxSelectBox"
                                [editorOptions]="DiscountEditorOptions">
                                <dxo-label text="Discount"></dxo-label>
                            </dxi-item>
                        </dx-form>
                    </div>
                </div>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>